import { useEffect, useState } from 'react';

export const useIsLoadingFonts = () => {
  const [isLoadingFonts, setIsLoadingFonts] = useState(false);

  useEffect(() => {
    if (!document.fonts) {
      return;
    }

    document.fonts.addEventListener('loadingdone', () => {
      setIsLoadingFonts(false);
    });
    document.fonts.addEventListener('loadingerror', () => {
      setIsLoadingFonts(false);
    });
    document.fonts.addEventListener('loading', () => {
      setIsLoadingFonts(true);
    });
  }, []);

  return isLoadingFonts;
};
